import { IFetchPublicStatsParams } from 'modules/stats/actions/fetchPublicStats';

import { ChainsPublicStatsContext } from './const';

export interface IChainsPublicStatsProviderProps {
  children: React.ReactNode;
  value: IFetchPublicStatsParams;
}

export const ChainsPublicStatsProvider = ({
  children,
  value,
}: IChainsPublicStatsProviderProps) => {
  return (
    <ChainsPublicStatsContext.Provider value={value}>
      {children}
    </ChainsPublicStatsContext.Provider>
  );
};
